import Marquee from "react-fast-marquee";

const brands = ["VERGE", "NORTHWIND", "LUMEN", "PIXELFORGE", "OBSIDIAN", "KAIROS", "MERIDIAN", "HELIX"];

export default function LogoMarquee() {
  return (
    <section className="py-14 border-y border-white/10 bg-[#070707]" data-testid="logo-marquee">
      <p className="text-center font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500 mb-8">
        Builders shipping on ArcaCentum
      </p>
      <Marquee gradient gradientColor="#070707" gradientWidth={120} speed={45} autoFill>
        {brands.map((b, i) => (
          <span
            key={i}
            className="font-display font-bold text-2xl md:text-3xl text-slate-600 mx-12 hover:text-white transition-colors duration-300"
          >
            {b}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
